import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';
import ArrowShowingDistance from '@/components/ArrowShowingDistance';

import Snippet from './Snippet';
import OutputWrapper from './OutputWrapper';

function ButtonWidthDemo() {
  const buttonWidth = 225;

  return (
    <Demo
      id="button-width-demo"
      initialValues={{
        fontSize: 100,
        unit: 'px',
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="Default font size"
          min={100}
          max={250}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoRadioControl
          key="unit"
          id="unit"
          label="Width unit"
          options={['px', 'rem']}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize, unit }) => {
        const actualButtonWidth =
          unit === 'px'
            ? buttonWidth
            : buttonWidth * (fontSize / 100);
        const actualFontSize = 1.25 * (fontSize / 100);

        return (
          <OuterWrapper>
            <Wrapper>
              <ButtonWrapper
                style={{
                  width: actualButtonWidth,
                }}
              >
                <Button style={{ fontSize: `${actualFontSize}rem` }}>
                  Random Button
                </Button>
              </ButtonWrapper>
              <ArrowWrapper>
                <ArrowShowingDistance
                  axis="horizontal"
                  distance={actualButtonWidth}
                />
              </ArrowWrapper>
            </Wrapper>
            <Snippet
              code={generateCodeSnippet({ unit })}
              minCodeHeight="11.125rem"
            />
          </OuterWrapper>
        );
      }}
    </Demo>
  );
}

function generateCodeSnippet({ unit }: { unit: 'px' | 'rem' }) {
  return `.button {
  font-size: 1.25rem;
  width: ${unit === 'px' ? '240px' : '15rem'};
  max-width: 100%;
}`;
}

const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 16px;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

const ButtonWrapper = styled.div`
  max-width: 100%;
`;

const Button = styled.div`
  background: var(--color-primary);
  font-size: 1.25rem;
  padding: 16px;
  color: white;
`;

const ArrowWrapper = styled.div`
  @media ${BREAKPOINTS.mdAndSmaller} {
    display: none;
  }
`;

export default ButtonWidthDemo;
